import { IProductDetails } from '@/interfaces/product';
import { create } from 'zustand';

const useHeaderStore = create((set: any) => ({
  text: '',
  setText: (t: string) => set(() => ({ text: t })),

  overlay: false,
  activateOverlay: (activate: boolean) =>
    set((state: any) => ({
      overlay: activate,
      searchPanel: activate ? state.searchPanel : activate,
      filterPanel: activate ? state.filterPanel : activate,
      navPanel: activate ? state.navPanel : activate,
      cartPanel: activate ? state.cartPanel : activate,
    })),

  searchPanel: false,
  openSearchPanel: (searchPanel: boolean) =>
    set((state: any) => {
      return {
        searchPanel,
        overlay: searchPanel,
        navPanel: searchPanel ? false : state.navPanel,
        filterPanel: searchPanel ? false : state.filterPanel,
        cartPanel: searchPanel ? false : state.cartPanel,
      };
    }),

  filterPanel: false,
  openFilterPanel: (filterPanel: boolean) =>
    set((state: any) => {
      return {
        filterPanel,
        overlay: filterPanel,
        navPanel: filterPanel ? false : state.navPanel,
        cartPanel: filterPanel ? false : state.cartPanel,
        searchPanel: filterPanel ? false : state.searchPanel,
      };
    }),

  navPanel: false,
  openNavPanel: (navPanel: boolean) =>
    set((state: any) => {
      return {
        navPanel,
        overlay: navPanel || state.searchPanel,
        searchPanel: navPanel ? false : state.searchPanel,
        filterPanel: navPanel ? false : state.filterPanel,
        cartPanel: navPanel ? false : state.cartPanel,
      };
    }),

  filtersAvailable: false,
  setFiltersAvailability: (filtersAvailable: boolean) => set((state: any) => ({ filtersAvailable })),

  banner: false,
  setBanner: (banner: boolean) => set((state: any) => ({ banner })),

  cartPanel: false,
  openCartPanel: (cartPanel: boolean) =>
    set((state: any) => ({
      cartPanel,
      overlay: cartPanel,
      navPanel: cartPanel ? false : state.navPanel,
      filterPanel: cartPanel ? false : state.filterPanel,
      searchPanel: cartPanel ? false : state.searchPanel,
    })),

  filterData: '',
  setFilterData: (filter: string) => set(() => ({ filterData: filter })),

  filterAttribute: [],
  setFilterAttribute: (attribute: any) => set(() => ({ filterAttribute: attribute })),

  priceRange: { Min: 0, Max: 0 },
  setPriceRange: (price: any) => set(() => ({ priceRange: { Min: price.Min, Max: price.Max } })),
  styleImageMapping: {},
  setStyleImageMapping: (styleImage: any) => set(() => ({ styleImageMapping: styleImage })),
  styleSVGSourceCode: [],
  setStyleSVGSourceCode: (styleSvg: string[]) => set(() => ({ styleSVGSourceCode: styleSvg })),

  filterLoading: false,
  setFilterLoading: (loading: boolean) => set((state: any) => ({ filterLoading: loading })),

  routerState: '',
  setRouterState: (routerState: string) => set(() => ({ routerState: routerState })),

  showloaderOverlay: false,
  setShowloaderOverlay: (showloaderOverlay: boolean) => set(() => ({ showloaderOverlay: showloaderOverlay })),
  sortBy: '',
  setSortByState: (sort: string) => set(() => ({ sortBy: sort })),

  clearPageIndex: false,
  setClearPageIndex: (clearPageIndex: boolean) => set((state: any) => ({ clearPageIndex })),

  colorDictionary: [],
  setColorDictionary: (colors: any) => set(() => ({ colorDictionary: colors })),

  orderTrackerLoading: false,
  setOrderTrackerLoading: (orderTrackerLoading: boolean) => set((state: any) => ({ orderTrackerLoading })),
  quickView: false,
  openQuickView: (quickView: boolean) => set((state: any) => ({ quickView })),
  quickViewLoading: false,
  openQuickViewLoading: (quickViewLoading: boolean) => set((state: any) => ({ quickViewLoading })),

  quickViewProduct: {} as IProductDetails,
  setQuickViewProduct: (quickViewProduct: IProductDetails) => set((state: IProductDetails) => ({ quickViewProduct })),
  quickViewSeName: '',
  setQuickViewSeName: (quickViewSeName: string) => set((state: string) => ({ quickViewSeName })),
}));

export default useHeaderStore;
